module.exports = __webpack_public_path__ + "img/facebook.b6fd513d.svg";